import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import { UpdateSlotRequest } from "interfaces/requests/Slots";
import { getURLWithQueryParams } from "utils/url";

const BASE_URL = "/slots";

export const fetchSlots = createAsyncThunk<
  string,
  "true" | "false" | undefined
>("slots/get", async (isLinkedParam) => {
  try {
    const url = getURLWithQueryParams(BASE_URL, {
      isLinked: isLinkedParam,
    });
    const response = await axios.get(url);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
});

export const linkSlots = createAsyncThunk(
  "slots/patch",
  async (data: UpdateSlotRequest) => {
    try {
      const response = await axios.patch(`${BASE_URL}/`, data);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
);
